/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2023 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import {createTabsListingSpin, placeListErrors} from "./front/_front";
import manufacturerSlider from "./sliders/manufacturerSlider";
import {getProductList, getUnitsData} from "./front/_productListFuctions";
import tabsSlider from "./sliders/tabsSlider";

export default function step1Standard(){

    let xhr_getJobTypeValueBrands = null;
    let xhr_getJobTypeProductList = null;

    $(document).on('change', '.js-jobUnits-controls', function (e){
        e.stopPropagation();
        let flag = [];
        $('.js-jobUnits-controls').each(function (index, el){
            flag[index] = false;
        });

        $('.js-jobUnits-controls').each(function (index, el){
            if( $(this).val() == '' ){
                flag[index] = false;
            }else{
                flag[index] = true;
            }
        });

        if(!flag.includes(false)){
            let _value = $('.js-job-type:checked').val();
            if( typeof _value != 'undefined' && _value !=  '' && _value !=  null){
                const data = [{name: "id_afpw_job_type_value", value: _value}];
                getJobTypeValueBrands(data);
            }
        }else{
            if($('.js-jobTypeValueBrands').length){
                $('.js-jobTypeValueBrands').remove();
            }
            if($('.js-jobProductList').length){
                $('.js-jobProductList').remove();
            }
        }
    })

    function getJobTypeValueBrands(data){

        xhr_getJobTypeValueBrands = $.ajax({
            method: "POST",
            url: afpw_ajax_url,
            beforeSend: function () {
                if(xhr_getJobTypeValueBrands != null){ xhr_getJobTypeValueBrands.abort(); }
                if($('.js-jobTypeValueBrands').length){
                    $('.js-jobTypeValueBrands').remove();
                }
                if($('.js-jobProductList').length){
                    $('.js-jobProductList').remove();
                }
                if($('.js-kx-flow .alert').length){
                    $('.js-kx-flow .alert').remove();
                }
                $('.js-kx-flow').append('<div class="kx-loader"></div>');
            },
            cache: false,
            data: {
                ajax: true,
                action: 'getJobTypeValueBrands',
                hash: afpw_hash,
                data: $.param(data)
            },
        }).done(function (data, textStatus, jqXHR){
            try {
                var obj = jQuery.parseJSON(data);
                if (obj.status == 'success') {
                    if($('.js-jobTypeValueBrands').length){
                        $('.js-jobTypeValueBrands').remove();
                    }
                    $('.js-kx-flow').append(obj.html);
                    manufacturerSlider();

                    //$('.js-jobTypeValueBrands').get(0).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                    if($('.js-jobTypeValueBrands').length){
                        var _top = $('.js-jobTypeValueBrands').offset().top;
                        window.scrollTo({
                            top: _top - 110,
                            behavior: "smooth"
                        });
                    }

                    const _checkedBrand = $('.js-kx-flow').find('.js-manufacturer-selection:checked');
                    if(_checkedBrand.length){
                        let data = getUnitsData();
                        if(!data){ return; }
                        setTimeout(function (){
                            getJobTypeProductList(data);
                        },10);
                    }

                } else {
                    if (typeof(obj.errors) != 'undefined' ) {
                        $.each(obj.errors, function(key,value) {
                            placeListErrors(value);
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            placeListErrors('Συνέβη ένα λάθος παρακαλώ δοκιμάστε αργότερα');
            console.log(errorThrown);
        }).always(function() {
            xhr_getJobTypeValueBrands = null;
            $('.kx-loader').remove();
        });
    }

    function getJobTypeProductList(data){

        xhr_getJobTypeProductList = $.ajax({
            method: "POST",
            url: afpw_ajax_url,
            beforeSend: function () {
                if(xhr_getJobTypeProductList != null){ xhr_getJobTypeProductList.abort(); }
                if($('.js-jobProductList').length){
                    $('.js-jobProductList').remove();
                }
                if($('.js-kx-flow .alert').length){
                    $('.js-kx-flow .alert').remove();
                }
                $('.js-kx-flow').append('<div class="kx-loader"></div>');
            },
            cache: false,
            data: {
                ajax: true,
                action: 'getJobTypeProductList',
                hash: afpw_hash,
                data: $.param(data)
            },
        }).done(function (data, textStatus, jqXHR){
            try {
                var obj = jQuery.parseJSON(data);
                if (obj.status == 'success') {
                    if($('.js-jobProductList').length){
                        $('.js-jobProductList').remove();
                    }
                    $('.js-kx-flow').append(obj.html);
                    createTabsListingSpin();
                    getProductList();
                    tabsSlider();

                    if($('.js-jobProductList').length){
                        var _top = $('.js-jobProductList').offset().top;
                        window.scrollTo({
                            top: _top - 110,
                            behavior: "smooth"
                        });
                    }

                } else {
                    if (typeof(obj.errors) != 'undefined' ) {
                        $.each(obj.errors, function(key,value) {
                            placeListErrors(value);
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            placeListErrors('Συνέβη ένα λάθος παρακαλώ δοκιμάστε αργότερα');
            console.log(errorThrown);
        }).always(function() {
            xhr_getJobTypeProductList = null;
            $('.kx-loader').remove();
        });
    }

}